module.exports = __webpack_public_path__ + "static/media/img-benefit-applewatch-1-mobile@3x.4ce5a4df.png";